// VK chart builder filter container sticky behavior
jQuery(document).ready(function () {
	jQuery(".vk-filter-container.sticky").each(function () {
		const $el = jQuery(this);
		let offsetTop = $el.offset().top;

		// Create placeholder
		const $placeholder = jQuery("<div class='vk-filter-placeholder'></div>");
		$placeholder.height($el.outerHeight());
		$el.after($placeholder);

		function updateSticky() {
			// Skip if inside a hidden tab panel
			const $panel = $el.closest(".tabs-panel");
			if ($panel.length && $panel.css("display") === "none") {
				return;
			}

			// Only recalculate offset when element is in normal flow
			if (!$el.hasClass("fixed")) {
				offsetTop = $el.offset().top;
				// Keep placeholder in sync (height changes when mobile filters expand/collapse)
				$placeholder.height($el.outerHeight());
			}

			if (jQuery(window).scrollTop() >= offsetTop) {
				$el.addClass("fixed");
				$placeholder.addClass("active");
			} else {
				$el.removeClass("fixed");
				$placeholder.removeClass("active");
			}
		}

		jQuery(window).on("scroll", updateSticky);

		// Re-evaluate on Foundation tab change (only for filters inside tabs)
		if ($el.closest(".tabs-content").length) {
			jQuery(document).on("change.zf.tabs", function (e) {
				if (e.namespace !== "zf.tabs") return;
				$el.removeClass("fixed");
				$placeholder.removeClass("active");
				$placeholder.height($el.outerHeight());
				setTimeout(updateSticky, 50);
			});
		}
	});
});